import React from 'react';

export interface TarjetaCreditoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const TarjetaCreditoIcon: React.FC<TarjetaCreditoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1.334 10.824h22m-20-6h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-18a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333.824h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default TarjetaCreditoIcon;
